/*
 * Sección "Shop by Age" — animación de entrada.
 *
 * Criterio: la animación es un adorno, nunca un requisito para ver el contenido.
 * Por eso el estado inicial (tarjetas ocultas) lo aplica este script y no el CSS:
 * si el JS falla o está bloqueado, las tarjetas se ven igual. El script está
 * diferido y la sección va debajo del pliegue, así que el cambio ocurre mucho
 * antes de que el usuario llegue a mirarla.
 *
 * Todo lo que se anima son `opacity` y `transform`, las dos únicas propiedades
 * que el navegador puede resolver en la GPU sin recalcular el layout. Por eso se
 * mantiene fluido incluso en un celular de gama media.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(section) {
    section.classList.add('is-visible');
  }

  function initSection(section) {
    if (!section || section.dataset.sbaReady === 'true') return;
    section.dataset.sbaReady = 'true';

    // Si el usuario pidió menos movimiento, no se oculta nada: se muestra y listo.
    if (REDUCED || section.dataset.animate !== 'true') return;

    section.classList.add('sba-ready');

    if (typeof IntersectionObserver !== 'function') {
      reveal(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          // La entrada ocurre una sola vez: no tiene sentido seguir observando
          // ni volver a animar cada vez que el usuario sube y baja.
          observer.unobserve(entry.target);
        });
      },
      // Se dispara un poco antes de que la sección entre en pantalla, para que
      // el usuario la encuentre ya empezando a aparecer y no arrancando de cero.
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
    );

    observer.observe(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.shop-by-age[data-section-id]').forEach(initSection);
  }

  initAll();

  // Editor de temas: la sección se vuelve a montar al editarla.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    // Al seleccionarla en el editor se muestra completa, sin esperar el scroll.
    (e.target.querySelectorAll ? e.target.querySelectorAll('.shop-by-age') : []).forEach(reveal);
  });
})();
